import dayjs from 'dayjs';

const DISMISS_KEY = 'freeTrialDismissDate';
const ORG_GUIDE_DISMISS_KEY = 'createOrgGuideDismissed';

// "오늘 하루 보지 않기" - localStorage에 날짜 저장, 자정(00:00) 기준 초기화
export function isDismissedToday(): boolean {
  const dismissed = localStorage.getItem(DISMISS_KEY);
  return dismissed === dayjs().format('YYYY-MM-DD');
}

export function dismissToday(): void {
  localStorage.setItem(DISMISS_KEY, dayjs().format('YYYY-MM-DD'));
}

// 조직 생성 안내 모달 - sessionStorage에 저장해 재로그인 시 다시 노출
export function isOrgGuideDismissedThisSession(): boolean {
  return sessionStorage.getItem(ORG_GUIDE_DISMISS_KEY) === 'true';
}

export function dismissOrgGuideThisSession(): void {
  sessionStorage.setItem(ORG_GUIDE_DISMISS_KEY, 'true');
}

// 로그아웃 시 호출 - 재로그인하면 조직이 없을 경우 모달이 다시 노출되도록 플래그 제거
export function clearOrgGuideDismissed(): void {
  sessionStorage.removeItem(ORG_GUIDE_DISMISS_KEY);
}
